var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestimonialQuoteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 550,
    height: 440,
    viewBox: "0 0 550 440",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266.661 13.3229C266.661 63.6061 266.661 88.7469 251.04 104.368C235.42 119.99 210.278 119.99 159.995 119.99C109.712 119.99 84.57 119.99 68.9492 104.368C53.3281 88.7469 53.3281 63.6061 53.3281 13.3229C53.3281 -36.9603 53.3281 -62.1019 68.9492 -77.7227C84.57 -93.3437 109.712 -93.3438 159.995 -93.3438C210.278 -93.3438 235.42 -93.3437 251.04 -77.7227C266.661 -62.1019 266.661 -36.9603 266.661 13.3229Z",
    stroke: "#E4EEFC",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.672 -13.3438V106.179C266.672 212.115 199.586 301.955 106.672 333.323",
    stroke: "#E4EEFC",
    strokeWidth: 30,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.661 13.3229C586.661 63.6061 586.661 88.7469 571.04 104.368C555.419 119.99 530.277 119.99 479.995 119.99C429.712 119.99 404.571 119.99 388.949 104.368C373.328 88.7469 373.328 63.6061 373.328 13.3229C373.328 -36.9603 373.328 -62.1019 388.949 -77.7227C404.571 -93.3437 429.712 -93.3438 479.995 -93.3438C530.277 -93.3438 555.419 -93.3437 571.04 -77.7227C586.661 -62.1019 586.661 -36.9603 586.661 13.3229Z",
    stroke: "#E4EEFC",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.672 -13.3438V106.179C586.672 212.115 519.587 301.955 426.672 333.323",
    stroke: "#E4EEFC",
    strokeWidth: 30,
    strokeLinecap: "round"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialQuoteIcon);
export default __webpack_public_path__ + "static/media/testimonial-quote-icon.82166793cdeff33f9b882cfeb91b56c1.svg";
export { ForwardRef as ReactComponent };